<template>
    <button type="button" class="btn btn-primary" :class="{'btn-outline-primary':outline}">
        Press Me
    </button>
</template>
